"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Online Training API
 * Online Training API documentation
 *
 * The version of the OpenAPI document: 0.0.81
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountApi = exports.AccountApiFactory = exports.AccountApiFp = exports.AccountApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * AccountApi - axios parameter creator
 * @export
 */
const AccountApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Operation Id: ActivateAccount - Difficulty: 2 - Roles can execute: everybody
         * @summary Kullanıcının register endpointi ile birlikte e-postasına gelen gönderilmiş olan kod ile hesabını onaylamasını sağlar. Not: Bu kısımda müşteri girişi henüz tamamlanmamıştır client JWT göndermeyecektir. Bu kısımdan sadece ROLE_CUSTOMER rolündeki hesaplar onaylanabilir. Bu işlem sonucunda hesap aktif edilmiş ise jwt geri dönüşü yapılmalıdır. JHipster default kullanılacaktır.
         * @param {ActivateAccountCommand} [activateAccountCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateAccount: (activateAccountCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/account/activate_account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(activateAccountCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ChangeMyPassword - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın şifresini değiştirmesini sağlar. JHipster default kullanılacaktır.
         * @param {ChangeMyPasswordCommand} [changeMyPasswordCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeMyPassword: (changeMyPasswordCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/account/change_my_password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeMyPasswordCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: CompleteCustomerProfile - Difficulty: 4 - Roles can execute: ROLE_CUSTOMER
         * @summary Müşteri hesaplarında hesabını onayladıktan sonra profile detaylarını tamamlaması istenir. Bu komut profil detaylarının veritabanına yazılması için gereklidir.
         * @param {any} avatar avatar
         * @param {string} customerProfileInfo customerProfileInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeCustomerProfile: (avatar, customerProfileInfo, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'avatar' is not null or undefined
            (0, common_1.assertParamExists)('completeCustomerProfile', 'avatar', avatar);
            // verify required parameter 'customerProfileInfo' is not null or undefined
            (0, common_1.assertParamExists)('completeCustomerProfile', 'customerProfileInfo', customerProfileInfo);
            const localVarPath = `/api/account/complete_customer_profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (avatar !== undefined) {
                localVarFormParams.append('avatar', avatar);
            }
            if (customerProfileInfo !== undefined) {
                localVarFormParams.append('customerProfileInfo', customerProfileInfo);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: DeleteMyAccount - Difficulty: 2 - Roles can execute: ROLE_CUSTOMER
         * @summary Bir kullanıcının kendi hesabını silmesini sağlar.
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyAccount: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/account/delete_my_account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: GetMyAccountDetails - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Herhangi bir hesabın kendi bilgilerini getirmesini sağlar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyAccountDetails: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/account/get_my_account_details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ListMyActivities - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış herhangi bir hesabın akvitivelerini listelemesini sağlar.
         * @param {number} [idOfLastActivityItem]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyActivities: (idOfLastActivityItem, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/account/list_my_activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (idOfLastActivityItem !== undefined) {
                localVarQueryParameter['idOfLastActivityItem'] = idOfLastActivityItem;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: Login - Difficulty: 2 - Roles can execute: everybody
         * @summary Sistemde bulunan tüm hesapların eposta ve şifre ile giriş yapabilmesini sağlar. JHipster default kullanılacaktır.
         * @param {LoginCommand} [loginCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: (loginCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/account/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loginCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: LostPassword - Difficulty: 2 - Roles can execute: everybody
         * @summary Misafir kullanıcının unuttuğu şifresini yenileyebilmesini sağlar. Bu işlem sonrasında şifresini unutan kullanıcının e-posta adresine kurtarma kodu gönderilir. Dikkat: E-posta gönderildiğinde UserAccount entitysinde bulunan LastAccountLostPasswordKeySentAt alanının şu anki zamana ayarlanması gerekiyor. Şayet LastAccountLostPasswordKeySentAt ile şu anki zaman arasında 3 dakikadan daha az bir süre var ise tekrardan e-posta gönderilmez ayrıca User entitysinde bulunan şifre sıfırlama anahtarı da değiştirilmez, fakat NextResendPossibleAt değeri oluşturulup başarılı olarak geri dönüş yapılır. Kullanıcının parametre olarak göndermiş olduğu e-posta sistemde yok ise exception fırlatılır. E-mail için JHipster default kullanılacaktır.
         * @param {LostPasswordCommand} [lostPasswordCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lostPassword: (lostPasswordCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/account/lost_password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(lostPasswordCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: RecoverPassword - Difficulty: 2 - Roles can execute: everybody
         * @summary Hesap şifresinin kurtarılmasını sağlar. LostPassword endpointi vasıtasıyla gönderilmiş olan e-posta içerisindeki kod burada kullanılır ve şayet User entitysindeki şifre kurtarma anahtarı ile uyuşuyorsa şifre değişimi kabul edilir. JHipster default kullanılacaktır.
         * @param {RecoverPasswordCommand} [recoverPasswordCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverPassword: (recoverPasswordCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/account/recover_password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(recoverPasswordCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: Register - Difficulty: 2 - Roles can execute: everybody
         * @summary E-posta ve şifre ile kullanıcı kaydı yapılabilmesini sağlar. Dikkat: Bu endpoint üzerinden sadece ROLE_CUSTOMER rolünde kayıt olunabilir. Kayıt sonrasında e-posta onay maili gitmesi gereklidir. Bu kısımda henüz hesap onaylanmadığından JWT dönüşü yapılmayacaktır. JHipster default kullanılacaktır.
         * @param {RegisterCommand} [registerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: (registerCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/account/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(registerCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ResendAccountActivationCode - Difficulty: 3 - Roles can execute: everybody
         * @summary Kayıt aşamasında, kayıt olmak isteyen kişinin e-posta hesabına hesap onaylama kodunun tekrar gönderilmesini sağlar. UserAccount entitysinde bulunan son konfirmasyon kodu gönderiminden minimum 3 dakika sonra kullanılabilir. Son konfirmasyon kodu gönderimi üzerinden 3 dakika geçmemiş ise başarılı cevap dönecektir fakat veritabanında herhangi bir değişiklik yapılmamış olmalıdır. Konfirmasyon kodu 6 haneli rastgele bir sayı olmalıdır. Hesap halihazırda onaylı ise veya e-postaya bağlı hesap bulunamaz ise BusinessException fırlatmalıdır. Email servisi olarak Jhipster default kullanılacaktır.
         * @param {ResendAccountActivationCodeCommand} [resendAccountActivationCodeCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendAccountActivationCode: (resendAccountActivationCodeCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/account/resend_account_activation_code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(resendAccountActivationCodeCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateMyAvatar - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın kendi profil fotoğrafını güncellemesini sağlar.
         * @param {UpdateMyAvatarCommand} [updateMyAvatarCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyAvatar: (updateMyAvatarCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/account/update_my_avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateMyAvatarCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateMyBirtdate - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın kendi doğum tarihini güncellemesini sağlar.
         * @param {UpdateMyBirthdateCommand} [updateMyBirthdateCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyBirtdate: (updateMyBirthdateCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/account/update_my_birtdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateMyBirthdateCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateMyHeight - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın kendi boy bilgisini güncellemesini sağlar.
         * @param {UpdateMyHeightCommand} [updateMyHeightCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyHeight: (updateMyHeightCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/account/update_my_height`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateMyHeightCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateMyWeight - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın kendi telefon numarası bilgisini güncellemesini sağlar.
         * @param {UpdateMyPhoneNumberCommand} [updateMyPhoneNumberCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyPhoneNumber: (updateMyPhoneNumberCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/account/update_my_phone_number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateMyPhoneNumberCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateMyWeight - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın kendi kilo bilgisini güncellemesini sağlar.
         * @param {UpdateMyWeightCommand} [updateMyWeightCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyWeight: (updateMyWeightCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/account/update_my_weight`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateMyWeightCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AccountApiAxiosParamCreator = AccountApiAxiosParamCreator;
/**
 * AccountApi - functional programming interface
 * @export
 */
const AccountApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AccountApiAxiosParamCreator)(configuration);
    return {
        /**
         * Operation Id: ActivateAccount - Difficulty: 2 - Roles can execute: everybody
         * @summary Kullanıcının register endpointi ile birlikte e-postasına gelen gönderilmiş olan kod ile hesabını onaylamasını sağlar. Not: Bu kısımda müşteri girişi henüz tamamlanmamıştır client JWT göndermeyecektir. Bu kısımdan sadece ROLE_CUSTOMER rolündeki hesaplar onaylanabilir. Bu işlem sonucunda hesap aktif edilmiş ise jwt geri dönüşü yapılmalıdır. JHipster default kullanılacaktır.
         * @param {ActivateAccountCommand} [activateAccountCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateAccount(activateAccountCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activateAccount(activateAccountCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ChangeMyPassword - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın şifresini değiştirmesini sağlar. JHipster default kullanılacaktır.
         * @param {ChangeMyPasswordCommand} [changeMyPasswordCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeMyPassword(changeMyPasswordCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changeMyPassword(changeMyPasswordCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: CompleteCustomerProfile - Difficulty: 4 - Roles can execute: ROLE_CUSTOMER
         * @summary Müşteri hesaplarında hesabını onayladıktan sonra profile detaylarını tamamlaması istenir. Bu komut profil detaylarının veritabanına yazılması için gereklidir.
         * @param {any} avatar avatar
         * @param {string} customerProfileInfo customerProfileInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeCustomerProfile(avatar, customerProfileInfo, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.completeCustomerProfile(avatar, customerProfileInfo, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: DeleteMyAccount - Difficulty: 2 - Roles can execute: ROLE_CUSTOMER
         * @summary Bir kullanıcının kendi hesabını silmesini sağlar.
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyAccount(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteMyAccount(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: GetMyAccountDetails - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Herhangi bir hesabın kendi bilgilerini getirmesini sağlar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyAccountDetails(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyAccountDetails(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ListMyActivities - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış herhangi bir hesabın akvitivelerini listelemesini sağlar.
         * @param {number} [idOfLastActivityItem]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyActivities(idOfLastActivityItem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMyActivities(idOfLastActivityItem, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: Login - Difficulty: 2 - Roles can execute: everybody
         * @summary Sistemde bulunan tüm hesapların eposta ve şifre ile giriş yapabilmesini sağlar. JHipster default kullanılacaktır.
         * @param {LoginCommand} [loginCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.login(loginCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: LostPassword - Difficulty: 2 - Roles can execute: everybody
         * @summary Misafir kullanıcının unuttuğu şifresini yenileyebilmesini sağlar. Bu işlem sonrasında şifresini unutan kullanıcının e-posta adresine kurtarma kodu gönderilir. Dikkat: E-posta gönderildiğinde UserAccount entitysinde bulunan LastAccountLostPasswordKeySentAt alanının şu anki zamana ayarlanması gerekiyor. Şayet LastAccountLostPasswordKeySentAt ile şu anki zaman arasında 3 dakikadan daha az bir süre var ise tekrardan e-posta gönderilmez ayrıca User entitysinde bulunan şifre sıfırlama anahtarı da değiştirilmez, fakat NextResendPossibleAt değeri oluşturulup başarılı olarak geri dönüş yapılır. Kullanıcının parametre olarak göndermiş olduğu e-posta sistemde yok ise exception fırlatılır. E-mail için JHipster default kullanılacaktır.
         * @param {LostPasswordCommand} [lostPasswordCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lostPassword(lostPasswordCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.lostPassword(lostPasswordCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: RecoverPassword - Difficulty: 2 - Roles can execute: everybody
         * @summary Hesap şifresinin kurtarılmasını sağlar. LostPassword endpointi vasıtasıyla gönderilmiş olan e-posta içerisindeki kod burada kullanılır ve şayet User entitysindeki şifre kurtarma anahtarı ile uyuşuyorsa şifre değişimi kabul edilir. JHipster default kullanılacaktır.
         * @param {RecoverPasswordCommand} [recoverPasswordCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverPassword(recoverPasswordCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.recoverPassword(recoverPasswordCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: Register - Difficulty: 2 - Roles can execute: everybody
         * @summary E-posta ve şifre ile kullanıcı kaydı yapılabilmesini sağlar. Dikkat: Bu endpoint üzerinden sadece ROLE_CUSTOMER rolünde kayıt olunabilir. Kayıt sonrasında e-posta onay maili gitmesi gereklidir. Bu kısımda henüz hesap onaylanmadığından JWT dönüşü yapılmayacaktır. JHipster default kullanılacaktır.
         * @param {RegisterCommand} [registerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(registerCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.register(registerCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ResendAccountActivationCode - Difficulty: 3 - Roles can execute: everybody
         * @summary Kayıt aşamasında, kayıt olmak isteyen kişinin e-posta hesabına hesap onaylama kodunun tekrar gönderilmesini sağlar. UserAccount entitysinde bulunan son konfirmasyon kodu gönderiminden minimum 3 dakika sonra kullanılabilir. Son konfirmasyon kodu gönderimi üzerinden 3 dakika geçmemiş ise başarılı cevap dönecektir fakat veritabanında herhangi bir değişiklik yapılmamış olmalıdır. Konfirmasyon kodu 6 haneli rastgele bir sayı olmalıdır. Hesap halihazırda onaylı ise veya e-postaya bağlı hesap bulunamaz ise BusinessException fırlatmalıdır. Email servisi olarak Jhipster default kullanılacaktır.
         * @param {ResendAccountActivationCodeCommand} [resendAccountActivationCodeCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendAccountActivationCode(resendAccountActivationCodeCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resendAccountActivationCode(resendAccountActivationCodeCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateMyAvatar - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın kendi profil fotoğrafını güncellemesini sağlar.
         * @param {UpdateMyAvatarCommand} [updateMyAvatarCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyAvatar(updateMyAvatarCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateMyAvatar(updateMyAvatarCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateMyBirtdate - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın kendi doğum tarihini güncellemesini sağlar.
         * @param {UpdateMyBirthdateCommand} [updateMyBirthdateCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyBirtdate(updateMyBirthdateCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateMyBirtdate(updateMyBirthdateCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateMyHeight - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın kendi boy bilgisini güncellemesini sağlar.
         * @param {UpdateMyHeightCommand} [updateMyHeightCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyHeight(updateMyHeightCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateMyHeight(updateMyHeightCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateMyWeight - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın kendi telefon numarası bilgisini güncellemesini sağlar.
         * @param {UpdateMyPhoneNumberCommand} [updateMyPhoneNumberCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyPhoneNumber(updateMyPhoneNumberCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateMyPhoneNumber(updateMyPhoneNumberCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateMyWeight - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın kendi kilo bilgisini güncellemesini sağlar.
         * @param {UpdateMyWeightCommand} [updateMyWeightCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyWeight(updateMyWeightCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateMyWeight(updateMyWeightCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AccountApiFp = AccountApiFp;
/**
 * AccountApi - factory interface
 * @export
 */
const AccountApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AccountApiFp)(configuration);
    return {
        /**
         * Operation Id: ActivateAccount - Difficulty: 2 - Roles can execute: everybody
         * @summary Kullanıcının register endpointi ile birlikte e-postasına gelen gönderilmiş olan kod ile hesabını onaylamasını sağlar. Not: Bu kısımda müşteri girişi henüz tamamlanmamıştır client JWT göndermeyecektir. Bu kısımdan sadece ROLE_CUSTOMER rolündeki hesaplar onaylanabilir. Bu işlem sonucunda hesap aktif edilmiş ise jwt geri dönüşü yapılmalıdır. JHipster default kullanılacaktır.
         * @param {ActivateAccountCommand} [activateAccountCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateAccount(activateAccountCommand, options) {
            return localVarFp.activateAccount(activateAccountCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ChangeMyPassword - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın şifresini değiştirmesini sağlar. JHipster default kullanılacaktır.
         * @param {ChangeMyPasswordCommand} [changeMyPasswordCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeMyPassword(changeMyPasswordCommand, options) {
            return localVarFp.changeMyPassword(changeMyPasswordCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: CompleteCustomerProfile - Difficulty: 4 - Roles can execute: ROLE_CUSTOMER
         * @summary Müşteri hesaplarında hesabını onayladıktan sonra profile detaylarını tamamlaması istenir. Bu komut profil detaylarının veritabanına yazılması için gereklidir.
         * @param {any} avatar avatar
         * @param {string} customerProfileInfo customerProfileInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeCustomerProfile(avatar, customerProfileInfo, options) {
            return localVarFp.completeCustomerProfile(avatar, customerProfileInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: DeleteMyAccount - Difficulty: 2 - Roles can execute: ROLE_CUSTOMER
         * @summary Bir kullanıcının kendi hesabını silmesini sağlar.
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyAccount(body, options) {
            return localVarFp.deleteMyAccount(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: GetMyAccountDetails - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Herhangi bir hesabın kendi bilgilerini getirmesini sağlar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyAccountDetails(options) {
            return localVarFp.getMyAccountDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ListMyActivities - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış herhangi bir hesabın akvitivelerini listelemesini sağlar.
         * @param {number} [idOfLastActivityItem]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyActivities(idOfLastActivityItem, options) {
            return localVarFp.listMyActivities(idOfLastActivityItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: Login - Difficulty: 2 - Roles can execute: everybody
         * @summary Sistemde bulunan tüm hesapların eposta ve şifre ile giriş yapabilmesini sağlar. JHipster default kullanılacaktır.
         * @param {LoginCommand} [loginCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginCommand, options) {
            return localVarFp.login(loginCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: LostPassword - Difficulty: 2 - Roles can execute: everybody
         * @summary Misafir kullanıcının unuttuğu şifresini yenileyebilmesini sağlar. Bu işlem sonrasında şifresini unutan kullanıcının e-posta adresine kurtarma kodu gönderilir. Dikkat: E-posta gönderildiğinde UserAccount entitysinde bulunan LastAccountLostPasswordKeySentAt alanının şu anki zamana ayarlanması gerekiyor. Şayet LastAccountLostPasswordKeySentAt ile şu anki zaman arasında 3 dakikadan daha az bir süre var ise tekrardan e-posta gönderilmez ayrıca User entitysinde bulunan şifre sıfırlama anahtarı da değiştirilmez, fakat NextResendPossibleAt değeri oluşturulup başarılı olarak geri dönüş yapılır. Kullanıcının parametre olarak göndermiş olduğu e-posta sistemde yok ise exception fırlatılır. E-mail için JHipster default kullanılacaktır.
         * @param {LostPasswordCommand} [lostPasswordCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lostPassword(lostPasswordCommand, options) {
            return localVarFp.lostPassword(lostPasswordCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: RecoverPassword - Difficulty: 2 - Roles can execute: everybody
         * @summary Hesap şifresinin kurtarılmasını sağlar. LostPassword endpointi vasıtasıyla gönderilmiş olan e-posta içerisindeki kod burada kullanılır ve şayet User entitysindeki şifre kurtarma anahtarı ile uyuşuyorsa şifre değişimi kabul edilir. JHipster default kullanılacaktır.
         * @param {RecoverPasswordCommand} [recoverPasswordCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverPassword(recoverPasswordCommand, options) {
            return localVarFp.recoverPassword(recoverPasswordCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: Register - Difficulty: 2 - Roles can execute: everybody
         * @summary E-posta ve şifre ile kullanıcı kaydı yapılabilmesini sağlar. Dikkat: Bu endpoint üzerinden sadece ROLE_CUSTOMER rolünde kayıt olunabilir. Kayıt sonrasında e-posta onay maili gitmesi gereklidir. Bu kısımda henüz hesap onaylanmadığından JWT dönüşü yapılmayacaktır. JHipster default kullanılacaktır.
         * @param {RegisterCommand} [registerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(registerCommand, options) {
            return localVarFp.register(registerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ResendAccountActivationCode - Difficulty: 3 - Roles can execute: everybody
         * @summary Kayıt aşamasında, kayıt olmak isteyen kişinin e-posta hesabına hesap onaylama kodunun tekrar gönderilmesini sağlar. UserAccount entitysinde bulunan son konfirmasyon kodu gönderiminden minimum 3 dakika sonra kullanılabilir. Son konfirmasyon kodu gönderimi üzerinden 3 dakika geçmemiş ise başarılı cevap dönecektir fakat veritabanında herhangi bir değişiklik yapılmamış olmalıdır. Konfirmasyon kodu 6 haneli rastgele bir sayı olmalıdır. Hesap halihazırda onaylı ise veya e-postaya bağlı hesap bulunamaz ise BusinessException fırlatmalıdır. Email servisi olarak Jhipster default kullanılacaktır.
         * @param {ResendAccountActivationCodeCommand} [resendAccountActivationCodeCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendAccountActivationCode(resendAccountActivationCodeCommand, options) {
            return localVarFp.resendAccountActivationCode(resendAccountActivationCodeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateMyAvatar - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın kendi profil fotoğrafını güncellemesini sağlar.
         * @param {UpdateMyAvatarCommand} [updateMyAvatarCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyAvatar(updateMyAvatarCommand, options) {
            return localVarFp.updateMyAvatar(updateMyAvatarCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateMyBirtdate - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın kendi doğum tarihini güncellemesini sağlar.
         * @param {UpdateMyBirthdateCommand} [updateMyBirthdateCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyBirtdate(updateMyBirthdateCommand, options) {
            return localVarFp.updateMyBirtdate(updateMyBirthdateCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateMyHeight - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın kendi boy bilgisini güncellemesini sağlar.
         * @param {UpdateMyHeightCommand} [updateMyHeightCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyHeight(updateMyHeightCommand, options) {
            return localVarFp.updateMyHeight(updateMyHeightCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateMyWeight - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın kendi telefon numarası bilgisini güncellemesini sağlar.
         * @param {UpdateMyPhoneNumberCommand} [updateMyPhoneNumberCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyPhoneNumber(updateMyPhoneNumberCommand, options) {
            return localVarFp.updateMyPhoneNumber(updateMyPhoneNumberCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateMyWeight - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Giriş yapmış hesabın kendi kilo bilgisini güncellemesini sağlar.
         * @param {UpdateMyWeightCommand} [updateMyWeightCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyWeight(updateMyWeightCommand, options) {
            return localVarFp.updateMyWeight(updateMyWeightCommand, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AccountApiFactory = AccountApiFactory;
/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
class AccountApi extends base_1.BaseAPI {
    /**
     * Operation Id: ActivateAccount - Difficulty: 2 - Roles can execute: everybody
     * @summary Kullanıcının register endpointi ile birlikte e-postasına gelen gönderilmiş olan kod ile hesabını onaylamasını sağlar. Not: Bu kısımda müşteri girişi henüz tamamlanmamıştır client JWT göndermeyecektir. Bu kısımdan sadece ROLE_CUSTOMER rolündeki hesaplar onaylanabilir. Bu işlem sonucunda hesap aktif edilmiş ise jwt geri dönüşü yapılmalıdır. JHipster default kullanılacaktır.
     * @param {ActivateAccountCommand} [activateAccountCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    activateAccount(activateAccountCommand, options) {
        return (0, exports.AccountApiFp)(this.configuration).activateAccount(activateAccountCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ChangeMyPassword - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
     * @summary Giriş yapmış hesabın şifresini değiştirmesini sağlar. JHipster default kullanılacaktır.
     * @param {ChangeMyPasswordCommand} [changeMyPasswordCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    changeMyPassword(changeMyPasswordCommand, options) {
        return (0, exports.AccountApiFp)(this.configuration).changeMyPassword(changeMyPasswordCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: CompleteCustomerProfile - Difficulty: 4 - Roles can execute: ROLE_CUSTOMER
     * @summary Müşteri hesaplarında hesabını onayladıktan sonra profile detaylarını tamamlaması istenir. Bu komut profil detaylarının veritabanına yazılması için gereklidir.
     * @param {any} avatar avatar
     * @param {string} customerProfileInfo customerProfileInfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    completeCustomerProfile(avatar, customerProfileInfo, options) {
        return (0, exports.AccountApiFp)(this.configuration).completeCustomerProfile(avatar, customerProfileInfo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: DeleteMyAccount - Difficulty: 2 - Roles can execute: ROLE_CUSTOMER
     * @summary Bir kullanıcının kendi hesabını silmesini sağlar.
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    deleteMyAccount(body, options) {
        return (0, exports.AccountApiFp)(this.configuration).deleteMyAccount(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: GetMyAccountDetails - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
     * @summary Herhangi bir hesabın kendi bilgilerini getirmesini sağlar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    getMyAccountDetails(options) {
        return (0, exports.AccountApiFp)(this.configuration).getMyAccountDetails(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ListMyActivities - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
     * @summary Giriş yapmış herhangi bir hesabın akvitivelerini listelemesini sağlar.
     * @param {number} [idOfLastActivityItem]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    listMyActivities(idOfLastActivityItem, options) {
        return (0, exports.AccountApiFp)(this.configuration).listMyActivities(idOfLastActivityItem, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: Login - Difficulty: 2 - Roles can execute: everybody
     * @summary Sistemde bulunan tüm hesapların eposta ve şifre ile giriş yapabilmesini sağlar. JHipster default kullanılacaktır.
     * @param {LoginCommand} [loginCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    login(loginCommand, options) {
        return (0, exports.AccountApiFp)(this.configuration).login(loginCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: LostPassword - Difficulty: 2 - Roles can execute: everybody
     * @summary Misafir kullanıcının unuttuğu şifresini yenileyebilmesini sağlar. Bu işlem sonrasında şifresini unutan kullanıcının e-posta adresine kurtarma kodu gönderilir. Dikkat: E-posta gönderildiğinde UserAccount entitysinde bulunan LastAccountLostPasswordKeySentAt alanının şu anki zamana ayarlanması gerekiyor. Şayet LastAccountLostPasswordKeySentAt ile şu anki zaman arasında 3 dakikadan daha az bir süre var ise tekrardan e-posta gönderilmez ayrıca User entitysinde bulunan şifre sıfırlama anahtarı da değiştirilmez, fakat NextResendPossibleAt değeri oluşturulup başarılı olarak geri dönüş yapılır. Kullanıcının parametre olarak göndermiş olduğu e-posta sistemde yok ise exception fırlatılır. E-mail için JHipster default kullanılacaktır.
     * @param {LostPasswordCommand} [lostPasswordCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    lostPassword(lostPasswordCommand, options) {
        return (0, exports.AccountApiFp)(this.configuration).lostPassword(lostPasswordCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: RecoverPassword - Difficulty: 2 - Roles can execute: everybody
     * @summary Hesap şifresinin kurtarılmasını sağlar. LostPassword endpointi vasıtasıyla gönderilmiş olan e-posta içerisindeki kod burada kullanılır ve şayet User entitysindeki şifre kurtarma anahtarı ile uyuşuyorsa şifre değişimi kabul edilir. JHipster default kullanılacaktır.
     * @param {RecoverPasswordCommand} [recoverPasswordCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    recoverPassword(recoverPasswordCommand, options) {
        return (0, exports.AccountApiFp)(this.configuration).recoverPassword(recoverPasswordCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: Register - Difficulty: 2 - Roles can execute: everybody
     * @summary E-posta ve şifre ile kullanıcı kaydı yapılabilmesini sağlar. Dikkat: Bu endpoint üzerinden sadece ROLE_CUSTOMER rolünde kayıt olunabilir. Kayıt sonrasında e-posta onay maili gitmesi gereklidir. Bu kısımda henüz hesap onaylanmadığından JWT dönüşü yapılmayacaktır. JHipster default kullanılacaktır.
     * @param {RegisterCommand} [registerCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    register(registerCommand, options) {
        return (0, exports.AccountApiFp)(this.configuration).register(registerCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ResendAccountActivationCode - Difficulty: 3 - Roles can execute: everybody
     * @summary Kayıt aşamasında, kayıt olmak isteyen kişinin e-posta hesabına hesap onaylama kodunun tekrar gönderilmesini sağlar. UserAccount entitysinde bulunan son konfirmasyon kodu gönderiminden minimum 3 dakika sonra kullanılabilir. Son konfirmasyon kodu gönderimi üzerinden 3 dakika geçmemiş ise başarılı cevap dönecektir fakat veritabanında herhangi bir değişiklik yapılmamış olmalıdır. Konfirmasyon kodu 6 haneli rastgele bir sayı olmalıdır. Hesap halihazırda onaylı ise veya e-postaya bağlı hesap bulunamaz ise BusinessException fırlatmalıdır. Email servisi olarak Jhipster default kullanılacaktır.
     * @param {ResendAccountActivationCodeCommand} [resendAccountActivationCodeCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    resendAccountActivationCode(resendAccountActivationCodeCommand, options) {
        return (0, exports.AccountApiFp)(this.configuration).resendAccountActivationCode(resendAccountActivationCodeCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateMyAvatar - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
     * @summary Giriş yapmış hesabın kendi profil fotoğrafını güncellemesini sağlar.
     * @param {UpdateMyAvatarCommand} [updateMyAvatarCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    updateMyAvatar(updateMyAvatarCommand, options) {
        return (0, exports.AccountApiFp)(this.configuration).updateMyAvatar(updateMyAvatarCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateMyBirtdate - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
     * @summary Giriş yapmış hesabın kendi doğum tarihini güncellemesini sağlar.
     * @param {UpdateMyBirthdateCommand} [updateMyBirthdateCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    updateMyBirtdate(updateMyBirthdateCommand, options) {
        return (0, exports.AccountApiFp)(this.configuration).updateMyBirtdate(updateMyBirthdateCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateMyHeight - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
     * @summary Giriş yapmış hesabın kendi boy bilgisini güncellemesini sağlar.
     * @param {UpdateMyHeightCommand} [updateMyHeightCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    updateMyHeight(updateMyHeightCommand, options) {
        return (0, exports.AccountApiFp)(this.configuration).updateMyHeight(updateMyHeightCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateMyWeight - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
     * @summary Giriş yapmış hesabın kendi telefon numarası bilgisini güncellemesini sağlar.
     * @param {UpdateMyPhoneNumberCommand} [updateMyPhoneNumberCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    updateMyPhoneNumber(updateMyPhoneNumberCommand, options) {
        return (0, exports.AccountApiFp)(this.configuration).updateMyPhoneNumber(updateMyPhoneNumberCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateMyWeight - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
     * @summary Giriş yapmış hesabın kendi kilo bilgisini güncellemesini sağlar.
     * @param {UpdateMyWeightCommand} [updateMyWeightCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    updateMyWeight(updateMyWeightCommand, options) {
        return (0, exports.AccountApiFp)(this.configuration).updateMyWeight(updateMyWeightCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AccountApi = AccountApi;
